import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { observer } from "mobx-react-lite";

import LoginPage from "~/views/login/LoginPage";
import RootAppointmentPage from "~/views/appointment/RootAppointmentPage";
import NotFoundPage from "~/views/not-found/NotFoundPage";
import { useNavigate } from "react-router-dom";

import { Header, Footer } from "@medical/onlinezdrav-ui";
import Breadcrumbs from "~/components/common/Breadcrumbs/Breadcrumbs";
import Preloader from "~/components/common/Preloader/Preloader";
import GlobalErrorModal from "~/components/modals/error/GlobalErrorModal";

// Styles
import s from "~/App.module.scss";

// Types
import RootStore from "~/store/RootStore";

// Routing
import RouterAuthorized from "~/router/RouterAuthorized";
import ROUTES from "~/utils/routes";

// Hooks
import useBreadcrumbs from "~/hooks/useBreadcrumbs";
import { useStore } from "~/hooks/useStore";

const App: React.FC = observer(() => {
  const location = useBreadcrumbs();
  const store: RootStore = useStore();
  const navigate = useNavigate();
  const [isMobileMenuOpen] = useState<boolean>(false);

  const onLocationChange = (city: any) => {
    if (city.id === store.cityStore.currentCity?.id) {
      return;
    }

    store.cityStore.setCurrentCity(city);
    navigate(ROUTES.LOGIN.PATHNAME, { replace: true });
    store.resetAppointmentProcess();
  };

  return (
    <div className={isMobileMenuOpen ? s.applicationFixed : ""}>
      <Header onLocationChange={onLocationChange} />

      <main className={s.applicationContainer}>
        {location && (
          <div className="screen-container">
            <div className={s.layoutBreadcrumbs}>
              <Breadcrumbs
                to={location.to}
                text={location.title}
                external={location.external}
              />
            </div>
          </div>
        )}

        <Routes>
          <Route path={ROUTES.LOGIN.PATHNAME} element={<LoginPage />} />

          <Route
            path={`${ROUTES.APPOINTMENT.PATHNAME}/*`}
            element={
              <RouterAuthorized>
                <RootAppointmentPage />
              </RouterAuthorized>
            }
          />

          <Route path="/" element={<Navigate to={ROUTES.LOGIN.PATHNAME} />} />

          <Route path={ROUTES.NOTFOUND.PATHNAME} element={<NotFoundPage />} />
        </Routes>
      </main>

      <Footer />

      <Preloader />

      <GlobalErrorModal isOpened={store.egisErrorStore.isEgisError} />
    </div>
  );
});

export default App;
